import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getOrderTrackingBackfillProgress = {
  name: "getOrderTrackingBackfillProgress" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    found: z.boolean(),
    running: z.boolean(),
    progress: z
      .object({
        totalCount: z.number(),
        totalProcessed: z.number(),
        workflowsStarted: z.number(),
        skippedNoShopify: z.number(),
        errors: z.number(),
        lastProcessedId: z.string().nullable(),
        progressPercent: z.string(),
      })
      .nullable(),
  }),
};
